import getEnvEndpoints from "./endpoints";

const endpoints = getEnvEndpoints();

export const trackPageView = (variables) => {
  if (endpoints.legacyAdobeEnabled === "true") {
    let pageName = window.location.pathname === "/"
      ? "PMIstandards+ | Landing Page"
      : `PMIstandards+ | ${window.location.pathname.split("/")[1]}` || "";
    window.PmiTag = {};
    window.PmiTag.Channel = "PMIstandards+";
    window.PmiTag.pageName = pageName || "";
    if (!window.PmiTag.pageName) {
      window.PmiTag["pageName"] = pageName || "";
    }
    window.s.pageName = pageName || "";
    if (!window.s.pageName) {
      window.s["pageName"] = pageName || "";
    }
    window.scObj = {
      ...window.scObj,
      ...variables,
    };
    window.s.t();
  }
};

export const trackSubscription = () => {
  if (endpoints.legacyAdobeEnabled === "true") {
    window.s.linkTrackVars = "eVar4";
    window.s.eVar4 = "stdplus_subscription";
    let data = window.s?.tl(this, "o", "PMIstandards+ Subscription Button");
    window.s.eVar4 = null;
  }
};

export const trackPurchase = () => {
  if (endpoints.legacyAdobeEnabled === "true") {
    window.s.linkTrackVars = "eVar4";
    window.s.eVar4 = "stdplus_payment";
    let data = window.s?.tl(this, "o", "PMIstandards+ Paypal Button");
    window.s.eVar4 = null;
  }
};

export const trackSpxPurchaseClick = () => {
  if (endpoints.legacyAdobeEnabled === "true") {
    window.s.linkTrackVars = "eVar4";
    window.s.eVar4 = "stdplus_spxPurchaseClick";
    let data = window.s?.tl(this, "o", "PMIstandards+ SPX Subscribe Click");
    window.s.eVar4 = null;
  }
};
